import React from "react";
import { Modal, Descriptions, Image, Tag } from "antd";
import {
  DEFAULT_SERVICE_CATEGORY_SECTION,
  SERVICE_CATEGORY_SECTION_OPTIONS,
  ServiceCategory,
} from "features/serviceCategory/model/serviceCategory";

type Props = {
  open: boolean;
  onClose: () => void;
  row?: ServiceCategory | null;
  title?: string;
};

export const ServiceCategoryViewModal: React.FC<Props> = ({
  open,
  onClose,
  row,
  title = "Просмотр категории",
}) => {
  const thumb = row?.photo?.filePathThumb || row?.photo?.filePath || "";
  const full = row?.photo?.filePath || thumb;

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnClose
      width={720}
    >
      {!row ? (
        <div>—</div>
      ) : (
        <>
          {full ? (
            <div style={{ marginBottom: 16 }}>
              <Image src={full} alt={row.nameRu} />
            </div>
          ) : null}

          <Descriptions bordered column={1} size="middle">
            <Descriptions.Item label="ID">{row.id ?? "—"}</Descriptions.Item>

            <Descriptions.Item label="Название (RU)">
              {row.nameRu || "—"}
            </Descriptions.Item>

            <Descriptions.Item label="Название (KY)">
              {row.nameKy || "—"}
            </Descriptions.Item>

            <Descriptions.Item label="Тип">{row.type}</Descriptions.Item>

            <Descriptions.Item label="Раздел">
              {SERVICE_CATEGORY_SECTION_OPTIONS.find(
                (o) =>
                  o.value === (row.section ?? DEFAULT_SERVICE_CATEGORY_SECTION),
              )?.label ?? row.section}
            </Descriptions.Item>

            <Descriptions.Item label="Порядок сортировки">
              {row.order ?? "—"}
            </Descriptions.Item>

            <Descriptions.Item label="Активная">
              {row.isActive ? (
                <Tag color="green">Да</Tag>
              ) : (
                <Tag color="red">Нет</Tag>
              )}
            </Descriptions.Item>

            <Descriptions.Item label="URL">{row.url || "—"}</Descriptions.Item>

            <Descriptions.Item label="Сервисы">
              {(row.serviceCodes?.length ?? 0) > 0
                ? row.serviceCodes.map((c) => <Tag key={c}>{c}</Tag>)
                : "—"}
            </Descriptions.Item>

            <Descriptions.Item label="Описание (RU)">
              {row.descriptionRu || "—"}
            </Descriptions.Item>

            <Descriptions.Item label="Описание (KY)">
              {row.descriptionKy || "—"}
            </Descriptions.Item>
          </Descriptions>
        </>
      )}
    </Modal>
  );
};
